module.exports = __webpack_public_path__ + "static/img/advantage3.9805d4ce.png";